import React from 'react';

import { saveSettings, resetApp } from '../actions/settings';

import InputBox from './inputbox';
import ButtonLoader from './button-loader';

class Settings extends React.Component {

  constructor(props) {
    super();
    const { settings } = props;
    this.state = {
      settings,
      saving: false,
      saved: false,
    };
  }

  // update a value in the settings object
  setValue = (name, value) => {
    const values = {
      ...this.state.settings,
      [name]: value,
    };
    this.setState({
      settings: values,
      saved: false,
      saving: false,
    });
  }

  // save to db
  save = () => {
    const { settings } = this.state;
    this.setState({
      saving: true,
      saved: false,
    });
    saveSettings(settings)
    .then(() => {
      this.setState({
        saving: false,
        saved: true,
      })
    })
    .catch(err => console.error(err));
  }

  render() {
    const { weight } = this.state.settings;
    const { saving, saved } = this.state;

    return (
      <div className="view settings">
        <header><h1>Settings</h1></header>

        <div className="calc-form">

          <InputBox
            label="Your Weight (kg)"
            name="weight"
            value={String(weight)}
            set={this.setValue}
          />

          { !saved ?
            <p>
              <ButtonLoader onClick={this.save} loading={saving}>Save</ButtonLoader>
            </p>
            :
            <p className="success-notice">Settings have been saved.</p>
          }

          <p>
            <button className="btn secondary" onClick={resetApp}>Reset App</button>
          </p>
        </div>


      </div>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/settings.js